const isFeatureValueObject = (value) => value !== null && typeof value === 'object';

export const getFeatureValueKey = (value, index) => {
    if (!isFeatureValueObject(value)) {
        return String(value ?? index);
    }

    return String(value.id ?? value.Id ?? value.value ?? value.Value ?? value.displayText ?? value.DisplayText ?? index);
};

export const getFeatureValue = (value) => {
    if (!isFeatureValueObject(value)) {
        return String(value ?? '');
    }

    return String(value.value ?? value.Value ?? value.id ?? value.Id ?? value.displayText ?? value.DisplayText ?? '');
};

export const getFeatureValueDisplayText = (value) => {
    if (!isFeatureValueObject(value)) {
        return String(value ?? '');
    }

    return String(value.displayText ?? value.DisplayText ?? value.value ?? value.Value ?? value.id ?? value.Id ?? '');
};

export const getSelectedFeatureValueDisplayText = (feature, selectedValue) => {
    if (selectedValue === undefined || selectedValue === null || selectedValue === '') {
        return 'Unselected';
    }

    if (Array.isArray(selectedValue)) {
        return selectedValue.length > 0
            ? selectedValue.map(value => getSelectedFeatureValueDisplayText(feature, value)).join(', ')
            : 'Unselected';
    }

    if (isFeatureValueObject(selectedValue)) {
        return getFeatureValueDisplayText(selectedValue);
    }

    const normalizedSelectedValue = String(selectedValue);
    const matchingValue = feature?.values?.find(value => getFeatureValue(value) === normalizedSelectedValue);
    return matchingValue ? getFeatureValueDisplayText(matchingValue) : normalizedSelectedValue;
};
